import classNames from 'classnames/bind';
import React from 'react';

import styles from './common.module.scss';

const cx = classNames.bind(styles);

const Command = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('message')}>Cancel the region of interest.</div>
    </div>
  );
};

export default Command;
